import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import * as events from '../../../../../events'
import { ROOT } from '../../../../../routes'
import * as DA from '../../../../../typeModules/events'
import t from './strings'
import { ButtonContainer, GetStartedButton } from './styles'

const { signupCTA } = t

const handleClick = (
  history,
  trackLandingPageHeader: (data: DA.LandingPageHeader) => Promise<any>
) => {
  const SCROLL_TIMEOUT_MS = 100
  const CLEAR_HASH_TIMEOUT_MS = 1100

  setTimeout(() => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    })
  }, SCROLL_TIMEOUT_MS)

  setTimeout(() => {
    history.push(`${ROOT}/signup/${  history.location.search}`)
    trackLandingPageHeader({
      action: DA.EventActions.Clicked,
      name: DA.HeaderNames.GetStartedCTA,
    })
  }, CLEAR_HASH_TIMEOUT_MS)
}

type ReduxProps = {
  trackLandingPageHeader?: (data: DA.LandingPageHeader) => Promise<any>
}

export const GetStarted: React.FC<RouteComponentProps & ReduxProps> = ({
  history,
  trackLandingPageHeader,
}) => {
  return (
    <ButtonContainer>
      <GetStartedButton
        onClick={() => handleClick(history, trackLandingPageHeader)}
      >
        {signupCTA()}
      </GetStartedButton>
    </ButtonContainer>
  )
}

const mapDispatchToProps = {
  trackLandingPageHeader: events.trackLandingPageHeader,
}

export default connect(null, mapDispatchToProps)(withRouter(GetStarted))
